import { globalEntitlements } from '../utils/globalEntitlements';

export const CONSTANT_CONTACT = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.constantContact.buyBox.bulletPoint1' },
        { title: 'productPage.constantContact.buyBox.bulletPoint2' },
        { title: 'productPage.constantContact.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.constantContact.buyBox.productName',
      interactService: {
        service: 'constant_contact',
        openInNewTab: true
      },
      ctaIcon: {
        src: '/s2/material-icons/openinnewrounded.svg',
        alt: ''
      }
    }],
    headerPicture: {
      src: '/s2/raster/tablet-sign-boxes.png',
      alt: 'productPage.constantContact.heroPicture.altText'
    },
    headline: 'productPage.constantContact.page.headline',
    partnerLogo: {
      src: '/s2/vector/partnership-constant-contact-email.svg',
      alt: ''
    },
    partnerReviewBlanks: [],
    subheader: 'productPage.constantContact.page.subheader'
  },
  benefit: {
    title: 'productPage.constantContact.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/markemailreadrounded.svg',
        title: 'productPage.constantContact.valueProp.propTitle1',
        description: 'productPage.constantContact.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/miscellaneousservicesrounded.svg',
        title: 'productPage.constantContact.valueProp.propTitle2',
        description: 'productPage.constantContact.valueProp.shortCopy2'
      },
      {
        icon: '/s2/icon/sparks-fill.svg',
        title: 'productPage.constantContact.valueProp.propTitle3',
        description: 'productPage.constantContact.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/sendrounded.svg',
    title: 'productPage.constantContact.topFeature.title',
    subheader: 'productPage.constantContact.topFeature.subheader',
    image: '/s2/raster/office-computer-brainstorming-chat.png',
    alt: 'productPage.constantContact.topFeature.altText'
  },
  assistance: {
    title: 'productPage.constantContact.needAssistance.title',
    getInTouch: 'productPage.constantContact.needAssistance.getInTouch',
    actions: 'productPage.constantContact.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.constantContact.buyBox.buttonLabel' }).allowMultiplePurchases().build()
};
